import { jsxs as n, jsx as a } from "react/jsx-runtime";
import { cn as i } from "../../lib/utils.js";
import { ChevronDownIcon as o } from "lucide-react";
function c({
  className: t,
  size: e = "default",
  ...r
}) {
  return /* @__PURE__ */ n(
    "div",
    {
      className: i(
        "group/native-select relative w-fit has-[select:disabled]:opacity-50",
        t
      ),
      "data-slot": "native-select-wrapper",
      "data-size": e,
      children: [
        /* @__PURE__ */ a(
          "select",
          {
            "data-slot": "native-select",
            "data-size": e,
            className: "h-8 w-full min-w-0 appearance-none rounded-lg border border-input bg-transparent py-1 pr-8 pl-2.5 text-sm transition-colors outline-none select-none selection:bg-primary selection:text-primary-foreground placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50 disabled:pointer-events-none disabled:cursor-not-allowed aria-invalid:border-destructive aria-invalid:ring-3 aria-invalid:ring-destructive/20 data-[size=sm]:h-7 data-[size=sm]:rounded-[min(var(--radius-md),10px)] data-[size=sm]:py-0.5 dark:bg-input/30 dark:hover:bg-input/50 dark:aria-invalid:border-destructive/50 dark:aria-invalid:ring-destructive/40",
            ...r
          }
        ),
        /* @__PURE__ */ a(o, { className: "pointer-events-none absolute top-1/2 right-2.5 size-4 -translate-y-1/2 text-muted-foreground select-none", "aria-hidden": "true", "data-slot": "native-select-icon" })
      ]
    }
  );
}
function p({
  className: t,
  ...e
}) {
  return /* @__PURE__ */ a(
    "option",
    {
      "data-slot": "native-select-option",
      className: i("bg-[Canvas] text-[CanvasText]", t),
      ...e
    }
  );
}
function u({
  className: t,
  ...e
}) {
  return /* @__PURE__ */ a(
    "optgroup",
    {
      "data-slot": "native-select-optgroup",
      className: i("bg-[Canvas] text-[CanvasText]", t),
      ...e
    }
  );
}
export {
  c as NativeSelect,
  u as NativeSelectOptGroup,
  p as NativeSelectOption
};
//# sourceMappingURL=native-select.js.map
